import { List } from 'immutable';
import { defaultMemoize } from 'reselect';

import {
    isResourceLoading,
    getResourceTotal,
    getResourcePage,
    getResourcePerPage,
} from './common';

const isHomeArticlesLoading = defaultMemoize(isResourceLoading);
const getHomeArticlesTotal = getResourceTotal;
const getHomeArticlesPage = getResourcePage;
const getHomeArticlesPerPage = getResourcePerPage;
const getHomeArticles = defaultMemoize(
    (data) => data.get('home_articles', List()),
);

export {
    isHomeArticlesLoading,
    getHomeArticlesTotal,
    getHomeArticlesPage,
    getHomeArticlesPerPage,
    getHomeArticles,
};
